module.exports = __webpack_public_path__ + "img/profile.859939c.jpg";